
export default [
    {
        path: "/appform/:formKey",
        name: "form",
        props: true,
        component: () => import(/* webpackChunkName: "form" */ "../views/FormViewer.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: "/form/:id",
        name: "form2",
        props: true,
        component: () => import(/* webpackChunkName: "form2" */ "../views/form/FormView.vue")
    },
    {
        path: "/form/:id/edit-response/:response_id",
        name: "edit_form2",
        props: true,
        component: () => import(/* webpackChunkName: "form2" */ "../views/form/FormView.vue")
    },
    {
        path: "/form/:id/view-response/:response_id",
        name: "view_form2",
        props: true,
        component: () => import(/* webpackChunkName: "form2" */ "../views/form/FormView.vue")
    },
    {
        path: "/form/:id/response/:response_id",
        name: "form2_response",
        props: true,
        component: () => import(/* webpackChunkName: "form2_response" */ "../views/form/FormResponse.vue")
    },
    {
        path: "/form-view/:form_id",
        name: "view_form",
        props: true,
        component: () => import(/* webpackChunkName: "view_form" */ "../views/form/ViewForm.vue"),
        meta: { requiresAuth: true }
    },
]